import {
  DialedDigitExtractionServerState,
  DialedDigitExtractionServerActionTypes,
  GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST,
  GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_FULFILLED,
  GET_DIALED_DIGIT_EXTRACTION_SERVER_PENDING,
  GET_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED,
  SELECT_DIALED_DIGIT_EXTRACTION_SERVER,
  CREATE_DIALED_DIGIT_EXTRACTION_SERVER_PENDING,
  CREATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED,
  DELETE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED,
  SET_DIALED_DIGIT_EXTRACTION_SERVER_LOADING,
} from './dialedDigitExtractionServer.types';

export const initialState: DialedDigitExtractionServerState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function dialedDigitExtractionServerReducer(
  state = initialState,
  action: DialedDigitExtractionServerActionTypes,
): DialedDigitExtractionServerState {
  switch (action.type) {
    case GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_DIALED_DIGIT_EXTRACTION_SERVER_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_DIALED_DIGIT_EXTRACTION_SERVER_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_DIALED_DIGIT_EXTRACTION_SERVER:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_DIALED_DIGIT_EXTRACTION_SERVER_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_DIALED_DIGIT_EXTRACTION_SERVER_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_DIALED_DIGIT_EXTRACTION_SERVER_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
